import validate from "validate.js";

export class Conta {

    contaId: string;
    hashConta: string;
    alias: string;
    nome: string;
    clienteStatusId: ContaStatus;
    clienteTipoId: ContaTipo;
    logo: string | null;
    usuarioOwner: number;
    emailContato: string | null;
    usuarioCadastroId: number;
    dataCadastro: Date;
    usuarioAlteracaoId: number | null;
    dataAlteracao: Date | null;
    
    constructor() {

    }

    validar() {
        let validacao: any = {
            nome: { presence: { allowEmpty: false, message: '^campoObrigatorio' } }
        };

        return validate.validate(this, validacao);
    }

    static fromRaw(raw: any): Conta {
        return Object.assign(new Conta(), raw);
    }
}

export enum ContaStatus {
    Ativo = 1,
    Bloqueado = 2,
    Inativo = 3
}

export enum ContaTipo {
    POC = 1,
    P = 2,
    M = 3,
    G = 4
}

export interface ContaLimitesConfiguracao {
    limiteAtivo: boolean;
    limiteCarteiras: number;
    limiteTemplateImportacao: number;
    limiteTemplateItemImportacao: number;
    limiteLista: number;
    limiteEstrategias: number;
}

export function obterLimitesPorContaTipo(contaTipo: ContaTipo): ContaLimitesConfiguracao {
    switch (contaTipo) {
        case ContaTipo.P:
            return { limiteAtivo: true, limiteCarteiras: 2, limiteTemplateImportacao: 2, limiteTemplateItemImportacao: 40, limiteLista: 1, limiteEstrategias: 4 };
        case ContaTipo.M:
            return { limiteAtivo: true, limiteCarteiras: 4, limiteTemplateImportacao: 4, limiteTemplateItemImportacao: 60, limiteLista: 4, limiteEstrategias: 12 };
        case ContaTipo.G:
            return { limiteAtivo: true, limiteCarteiras: 4, limiteTemplateImportacao: 8, limiteTemplateItemImportacao: 90, limiteLista: 8, limiteEstrategias: 32 };
        case ContaTipo.POC:
        default:
            return { limiteAtivo: true, limiteCarteiras: 2, limiteTemplateImportacao: 1, limiteTemplateItemImportacao: 20, limiteLista: 1, limiteEstrategias: 2 };
    }
}

export class CriarConta {
    contaNome: string = '';
    contaAlias: string = '';
    contaTipo: ContaTipo | null = null;
    usuarioOwnerNome: string = '';
    usuarioOwnerLogin: string = '';
    usuarioOwnerEmail: string = '';
    elasticSearchHost: string = '';
    elasticSearchUrl: string = '';
    elasticSearchUsuario: string = '';
    elasticSearchSenha: string = '';
    limiteAtivo: boolean = true;
    limiteCarteiras: number | null = null;
    limiteTemplateImportacao: number | null = null;
    limiteTemplateItemImportacao: number | null = null;
    limiteLista: number | null = null;
    limiteEstrategias: number | null = null;

    aplicarLimitesPorTipo(): void {
        if (this.contaTipo == null) return;
        const limites = obterLimitesPorContaTipo(this.contaTipo);
        this.limiteAtivo = limites.limiteAtivo;
        this.limiteCarteiras = limites.limiteCarteiras;
        this.limiteTemplateImportacao = limites.limiteTemplateImportacao;
        this.limiteTemplateItemImportacao = limites.limiteTemplateItemImportacao;
        this.limiteLista = limites.limiteLista;
        this.limiteEstrategias = limites.limiteEstrategias;
    }

    validar() {
        let validacao: any = {
            contaNome: { presence: { allowEmpty: false, message: '^campoObrigatorio' } },
            contaAlias: { presence: { allowEmpty: false, message: '^campoObrigatorio' } },
            contaTipo: { presence: { allowEmpty: false, message: '^campoObrigatorio' } },
            usuarioOwnerNome: { presence: { allowEmpty: false, message: '^campoObrigatorio' } },
            usuarioOwnerLogin: { presence: { allowEmpty: false, message: '^campoObrigatorio' } },
            usuarioOwnerEmail: {
                presence: { allowEmpty: false, message: '^campoObrigatorio' },
                email: { message: '^emailInvalido' }
            }
        };

        return validate.validate(this, validacao);
    }
}

export interface CriarContaResult {
    contaId: string;
    hashConta: string;
    alias: string;
    nome: string;
    usuarioOwnerNome: string;
    usuarioOwnerLogin: string;
    usuarioOwnerSenha: string;
    usuarioOwnerEmail: string;
    usuarioApiKeyNome: string;
    usuarioApiKeyLogin: string;
}

export class ContaConfiguracao {
    contaId: string;
    hashConta: string;
    alias: string;
    nome: string;
    clienteTipoId: ContaTipo;
    limiteAtivo: boolean;
    limiteCarteiras: number | null;
    limiteTemplateImportacao: number | null;
    limiteTemplateItemImportacao: number | null;
    limiteLista: number | null;
    limiteEstrategias: number | null;
    elasticSearchHost: string;
    elasticSearchUrl: string;
    elasticSearchUsuario: string;
    elasticSearchSenha: string;

    static fromRaw(raw: any): ContaConfiguracao {
        const config = Object.assign(new ContaConfiguracao(), {
            contaId: raw.contaId ?? raw.ContaId,
            hashConta: raw.hashConta ?? raw.HashConta,
            alias: raw.alias ?? raw.Alias,
            nome: raw.nome ?? raw.Nome,
            clienteTipoId: raw.clienteTipoId ?? raw.ClienteTipoId,
            limiteAtivo: raw.limiteAtivo ?? raw.LimiteAtivo ?? true,
            limiteCarteiras: raw.limiteCarteiras ?? raw.LimiteCarteiras ?? null,
            limiteTemplateImportacao: raw.limiteTemplateImportacao ?? raw.LimiteTemplateImportacao ?? null,
            limiteTemplateItemImportacao: raw.limiteTemplateItemImportacao ?? raw.LimiteTemplateItemImportacao ?? null,
            limiteLista: raw.limiteLista ?? raw.LimiteLista ?? null,
            limiteEstrategias: raw.limiteEstrategias ?? raw.LimiteEstrategias ?? null,
            elasticSearchHost: raw.elasticSearchHost ?? raw.ElasticSearchHost ?? '',
            elasticSearchUrl: raw.elasticSearchUrl ?? raw.ElasticSearchUrl ?? '',
            elasticSearchUsuario: raw.elasticSearchUsuario ?? raw.ElasticSearchUsuario ?? '',
            elasticSearchSenha: raw.elasticSearchSenha ?? raw.ElasticSearchSenha ?? ''
        });

        if (config.clienteTipoId != null) {
            const limitesPadrao = obterLimitesPorContaTipo(config.clienteTipoId);
            config.limiteCarteiras = config.limiteCarteiras ?? limitesPadrao.limiteCarteiras;
            config.limiteTemplateImportacao = config.limiteTemplateImportacao ?? limitesPadrao.limiteTemplateImportacao;
            config.limiteTemplateItemImportacao = config.limiteTemplateItemImportacao ?? limitesPadrao.limiteTemplateItemImportacao;
            config.limiteLista = config.limiteLista ?? limitesPadrao.limiteLista;
            config.limiteEstrategias = config.limiteEstrategias ?? limitesPadrao.limiteEstrategias;
        }

        return config;
    }

    validarLimites() {
        const validacao: any = {
            limiteCarteiras: {
                presence: { allowEmpty: false, message: '^campoObrigatorio' },
                numericality: { onlyInteger: true, greaterThan: 0, message: '^valorInvalido' }
            },
            limiteTemplateImportacao: {
                presence: { allowEmpty: false, message: '^campoObrigatorio' },
                numericality: { onlyInteger: true, greaterThan: 0, message: '^valorInvalido' }
            },
            limiteTemplateItemImportacao: {
                presence: { allowEmpty: false, message: '^campoObrigatorio' },
                numericality: { onlyInteger: true, greaterThan: 0, message: '^valorInvalido' }
            },
            limiteLista: {
                presence: { allowEmpty: false, message: '^campoObrigatorio' },
                numericality: { onlyInteger: true, greaterThan: 0, message: '^valorInvalido' }
            },
            limiteEstrategias: {
                presence: { allowEmpty: false, message: '^campoObrigatorio' },
                numericality: { onlyInteger: true, greaterThan: 0, message: '^valorInvalido' }
            }
        };

        return validate.validate(this, validacao);
    }
}

export interface AtualizarContaLimites {
    limiteCarteiras: number;
    limiteTemplateImportacao: number;
    limiteTemplateItemImportacao: number;
    limiteLista: number;
    limiteEstrategias: number;
}